const JOSH = 'Clo1Va5v4pNuvE1TqHPNeKWFGay2'
const JASON = 'yJcDi4z2bffFtKq1jXI3deN8M9r1'
const LAYNE = '2S1n15f3I0OJjgpLx5pMlHdAfT13'
const CASEY = '5kpEsEowxGNSsdpPjQpS3PoL2g02'
const RACHEL = 'r1noJUdvSoZX6LIesj9eBNA5yEx1'
const OLIVIA = 'AmtbH8WVMsOneNemxsGcShyc9IE2'
const BRANDY = '9tWzGNjoUZWFjonz2PJJpAnkGxg1'
const SUSAN = 'WK7NrDb812UPUK2x7VZynNArOIo2'
const RUTH = 'RMv8Utnqrfg3UiVwSazoLs8lFE43'

const checkUserAccess = function (userID, accessLevel) {
  if (userID === JOSH) {
    return true
  }

  if (userID === LAYNE && (accessLevel === 'SUPPORT' || accessLevel === 'FULL_TIME' || accessLevel === 'LAYNE')) {
    return true
  } else if (userID === CASEY && (accessLevel === 'SUPPORT' || accessLevel === 'FULL_TIME' || accessLevel === 'CASEY')) {
    return true
  } else if (userID === JASON && (accessLevel === 'SUPPORT' || accessLevel === 'FULL_TIME' || accessLevel === 'JASON')) {
    return true
  } else if (userID === RACHEL && (accessLevel === 'SUPPORT' || accessLevel === 'RACHEL')) {
    return true
  } else if (userID === BRANDY && (accessLevel === 'SUPPORT' || accessLevel === 'BRANDY')) {
    return true
  } else if (userID === OLIVIA && (accessLevel === 'SUPPORT' || accessLevel === 'OLIVIA')) {
    return true
  } else if (userID === SUSAN && (accessLevel === 'SUPPORT' || accessLevel === 'SUSAN')) {
    return true
  } else if (userID === RUTH && (accessLevel === 'SUPPORT' || accessLevel === 'RUTH' || accessLevel === 'FULL_TIME')) {
    return true
  }

  return false
}

export default {
  checkUserAccess
}
